import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { BlueDataService } from '../services/blue-data.service';
import { BlueDataActionTypes } from './blue-data.actions';
import { switchMap, map, catchError, withLatestFrom } from 'rxjs/operators';
import { BlueData } from '../models/blue-data.model';

import * as fromBlueData from './../store/blue-data.actions';
import { of } from 'rxjs';
import { Store, select } from '@ngrx/store';
import { AppState } from '../../reducers/index';
import { getUser } from '../../auth/store/auth.selectors';

@Injectable()
export class BlueDataEffects {

  constructor(private actions$: Actions, private bluedataService: BlueDataService, private store: Store<AppState>) {}

  @Effect()
  query$ = this.actions$.pipe(
    ofType(BlueDataActionTypes.BLUEDATA_QUERY),
    withLatestFrom(this.store.pipe(select(getUser))),
    switchMap(([, user]: any) => this.bluedataService.get(user.uid)
      .pipe(
        map((data: any) => {
          const bluedataData: BlueData[] = data.map((res: any) => {
            const key = res.payload.key;
            const bluedata: BlueData = res.payload.val();
            const myDate = new Date().getUTCDate();
            const myDate2 = new Date().getMonth() + 1;
            const myDate3 = new Date().getUTCFullYear();
            return {
              key: key,
              id: bluedata.id,
              name: bluedata.name,
              description: bluedata.description,
              phone: bluedata.phone,
              page: bluedata.page,
              address: bluedata.address,
              postcode: bluedata.postcode,
              phone2: bluedata.phone2,
              status: bluedata.status, 
              industry: bluedata.industry,
              date: bluedata.date,
              hashtag: bluedata.hashtag,
              username: bluedata.username,
              lead: bluedata.lead,
              pulledCount: bluedata.pulledCount,
              hashAll: bluedata.hashAll,
              leadCount: bluedata.leadCount,
              datesaved: myDate
            };
          });
          return (new fromBlueData.BlueDataLoaded({ bluedatas: bluedataData }));
        }),
        catchError(error => {
          return of(new fromBlueData.BlueDataError({ error }));
        })
      )
    ),
  );

  @Effect({ dispatch: false })
  added$ = this.actions$.pipe(
    ofType(BlueDataActionTypes.BLUEDATA_ADDED),
    map((action: fromBlueData.BlueDataAdded) => action.payload),
    withLatestFrom(this.store.pipe(select(getUser))),
    switchMap(([payload, user]: any) => this.bluedataService.add(payload.bluedata, user.uid))
  );

  @Effect({ dispatch: false })
  edit$ = this.actions$.pipe(
    ofType(BlueDataActionTypes.BLUEDATA_EDITED),
    map((action: fromBlueData.BlueDataEdited) => action.payload),
    withLatestFrom(this.store.pipe(select(getUser))),
    switchMap(([payload, user]: any) => this.bluedataService.update(payload.bluedata, user.uid)
    .pipe(
      catchError( error => {
      return of(new fromBlueData.BlueDataError({ error }));
    }))
    )
  );

  @Effect({ dispatch: false })
  save$ = this.actions$.pipe(
    ofType(BlueDataActionTypes.BLUEDATA_SAVED),
    map((action: fromBlueData.BlueDataSaved) => action.payload),
    withLatestFrom(this.store.pipe(select(getUser))),
    switchMap(([payload, user]: any) => this.bluedataService.save(payload.bluedata, user.uid)
    .pipe(
      catchError( error => {
      return of(new fromBlueData.BlueDataError({ error }));
    }))
    )
  );

  @Effect({ dispatch: false })
  delete$ = this.actions$.pipe(
    ofType(BlueDataActionTypes.BLUEDATA_DELETED),
    map((action: fromBlueData.BlueDataDeleted) => action.payload),
    withLatestFrom(this.store.pipe(select(getUser))),
    switchMap(([payload, user]: any) => this.bluedataService.delete(payload.bluedata, user.uid))
  );
}
